import { FC, Fragment } from 'react';
import { ProposalPackage } from 'ts/shared/interfaces/ProposalData';
import ProposalHtl from './ProposalHtl';
import ProposalFlt from './ProposalFlt';
import { useTranslation } from 'react-i18next';
import ProposalEditHead from './ProposalEditHead';
import useRemovedItem from './useRemovedItem';
import { checkAHAVI } from 'utils/utils';
import { dateFormat } from 'utils/shared/utils';
import { formatFltPersons } from 'utils/shared/proposal';

interface ProposalPcgProps {
  packages: ProposalPackage[];
  proposalId: string;
  displayPrice: boolean;
}

const ProposalPcg: FC<ProposalPcgProps> = ({ packages, ...props }) => {
  const { t } = useTranslation();
  const removedItem = useRemovedItem(props.proposalId);

  const gds = [
    ...(packages[0].flights[0].gdsFlyAirs || []),
    ...(packages[0].flights?.[1]?.gdsFlyAirs || []),
  ];
  const flight = {
    ...packages[0].flights[0],
    gdsFlyAirs: gds,
    flightType: 'RoundTrip',
    remarks: [{ name: packages[0].supplier?.code }],
  };
  const baggage = () => {
    return (
      <div>
        {packages[0].hotels[0].rooms?.map((room, roomIndex) => (
          <div key={roomIndex}>
            {room.supplements.length > 0 && (
              <Fragment>
                <div> {t('hotel.room') + ' ' + (roomIndex + 1)} </div>
                {room.supplements.map((payment, paxIndex) => (
                  <div key={paxIndex}>
                    <span
                      className="pr-bold"
                      dangerouslySetInnerHTML={{ __html: payment.name }}
                    ></span>
                  </div>
                ))}
              </Fragment>
            )}
          </div>
        ))}
      </div>
    );
  };
  return (
    <div className="pr-hotel-card-wr">
      <div className={'pr-hotel-card' + (removedItem ? ' pr-hotel-removed' : '')}>
        <div className="pr-hotel-card-title pr-flex-between">
          <div className="pr-flex-row">
            {t('package.package')}:{' '}
            <div className="pr-flex-row pr-ph-5">
              <span>{packages[0].hotels[0].hotel.name}</span>,
              <span className="pr-ph-5">
                {dateFormat(packages[0].hotels[0].rooms[0]?.startDate, 'dd MMM yyyy', 'en')}
              </span>
              <span>({packages[0].hotels[0].rooms[0]?.nights})</span>
            </div>
          </div>
          <ProposalEditHead proposalId={props.proposalId} displayPrice={props.displayPrice} />
        </div>

        <ProposalHtl hotels={packages[0].hotels} hideWrapper proposalId={props.proposalId} />
        <div className="pr-mt-20"></div>
        <div className="pr-hotel-title pr-flex-row">
          {t('flight.flight')}:{' '}
          <div className="pr-flex-row pr-ph-5">
            {gds.map((bound, index) => (
              <span key={index} className="pr-flex-row">
                <span className="pr-mr-3">
                  {bound.departureAirport.code} - {bound.arrivalAirport.code},{' '}
                </span>
                <span>{dateFormat(bound.departureDateTime, 'dd/MM', 'en')}</span>

                {index !== gds.length - 1 && <span className="pr-ph-3">|</span>}
              </span>
            ))}
            ,<span className="pr-ph-3">{formatFltPersons(packages[0].flights[0], t)}</span>
          </div>
        </div>

        <ProposalFlt
          flight={flight}
          hideWrapper
          isPackage
          renderBaggage={baggage}
          proposalId={props.proposalId}
          displayPrice={false}
        />

        {packages[0].displayNote?.name && (
          <div
            className={
              'pr-notes' + (checkAHAVI(packages[0].displayNote?.name) ? ' pr-rtl' : ' pr-ltr')
            }
          >
            <span className="pr-mr-5">{t('notes')}: </span>{' '}
            <div
              className="pr-bold"
              dangerouslySetInnerHTML={{
                __html: packages[0].displayNote?.name.replaceAll(/\n/g, '<br />'),
              }}
            ></div>
          </div>
        )}
      </div>
      <div className="pr-divider"></div>
    </div>
  );
};

export default ProposalPcg;
